import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	documentExtractionSocket: {
		byProductId: {}
	}
};

export const multipleTechpackJourneySlice = createSlice({
	name: 'multipleTechpackJourney',
	initialState,
	reducers: {
		setDocumentExtractionSocketMessage: (state, action) => {
			const msg = action.payload;
			const id = msg?.data?.productId ?? msg?.data?.id;
			if (id != null && id !== '') {
				state.documentExtractionSocket.byProductId[id] = msg;
			}
		},
		clearDocumentExtractionSocketMessages: (state) => {
			state.documentExtractionSocket = {
				byProductId: {}
			};
		}
	}
});

export const { setDocumentExtractionSocketMessage, clearDocumentExtractionSocketMessages } =
	multipleTechpackJourneySlice.actions;

export default multipleTechpackJourneySlice.reducer;
